import { useCallback, useMemo, useRef, useState } from "react";
import useSnackbar from "src/store/useSnackbar";
import { BILLING_TERM_KEYS, BILLING_TERMS_REQUIRED_MESSAGE } from "../constants/billing";
import { useMonthlyBilling } from "../pg/useMonthlyBilling";
const createAgreements = (checked)=>BILLING_TERM_KEYS.reduce((acc, key)=>({
            ...acc,
            [key]: checked
        }), {});
/**
 * 월구독(빌링) 결제수단 선택 + 필수 약관 동의 상태
 *
 * 결제 CTA가 형제 컴포넌트인 CheckoutPayment(우측 sticky 패널)에 있어
 * CheckoutView에서 호출하고 상태를 아래로 내려준다.
 * checkout 페이지 스코프 상태이므로 전역 store 대신 훅으로 관리해
 * 페이지 이탈 시 자동으로 정리되게 한다.
 *
 * 미동의 상태는 여기서 막는다. 등록창까지 가지 못하므로 가입 요청의 termsAgreed는 항상 true다.
 */ export const useSubscriptionBilling = ()=>{
    const { addSnackbar  } = useSnackbar();
    const { requestBillingAuth  } = useMonthlyBilling();
    const [method, setMethod] = useState("CARD");
    const [agreements, setAgreements] = useState(()=>createAgreements(false));
    // 중복 호출 차단은 state가 아니라 ref로 한다. state는 리렌더 이후에야 반영되어
    // 같은 틱에 들어온 두 번째 클릭이 갱신 전 값을 보고 그대로 통과한다.
    const isRequestingRef = useRef(false);
    /** 마스터 체크박스 상태이기도 하다. 하나라도 해제되면 false. */ const isAllAgreed = useMemo(()=>BILLING_TERM_KEYS.every((key)=>agreements[key]), [
        agreements
    ]);
    const toggleTerm = useCallback((key, checked)=>{
        setAgreements((prev)=>({
                ...prev,
                [key]: checked
            }));
    }, []);
    const toggleAllTerms = useCallback((checked)=>{
        setAgreements(createAgreements(checked));
    }, []);
    const requestBilling = useCallback(async ()=>{
        if (isRequestingRef.current) return;
        if (!isAllAgreed) {
            addSnackbar({
                message: BILLING_TERMS_REQUIRED_MESSAGE,
                variant: "error"
            });
            return;
        }
        try {
            isRequestingRef.current = true;
            // 성공 시 토스 빌링 등록창으로 리다이렉트되므로 이 아래 코드는 실행되지 않는다.
            await requestBillingAuth(method);
        } catch (error) {
            var _error_message;
            addSnackbar({
                message: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : "정기결제 등록 요청에 실패했어요.",
                variant: "error"
            });
        } finally{
            // 성공 시엔 페이지가 토스로 떠나 실행되지 않는다. 페이지가 남아있는 경우에만 락을 푼다.
            isRequestingRef.current = false;
        }
    }, [
        addSnackbar,
        isAllAgreed,
        method,
        requestBillingAuth
    ]);
    return {
        method,
        setMethod,
        agreements,
        isAllAgreed,
        toggleTerm,
        toggleAllTerms,
        requestBilling
    };
};
